import React, { useEffect } from 'react'
import View from './view.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export default function Logic(props) {
  let app = useDataValue({
    context: 'app',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let installAppid = useDataValue({
    context: 'tab',
    path: 'selected.install_app_id',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  useEffect(() => {
    if (app.id !== installAppid) return

    // TODO: if app is already installed, manage or fail?
    if (app.companies.lenght > 0) {
      submit({ type: 'manage', app_id: app.id })
    } else {
      setFlowTo(
        normalizePath(props.viewPath, '../ConnectionAction/Install/Content')
      )
    }
  }, [])

  return <View {...props} />
}
